import { REACT_APP_API_BASE_URL } from '../config';

export const getApiUrl = (loginType, endpoint)  => {
    const prefix = loginType === 'guts' ? '/web/guts' : '/web/pos';
    return `${REACT_APP_API_BASE_URL}${prefix}${endpoint}`;
}

export const POS_API_BASE_URL = 'https://pos-api.givadiva.co/v2';
